import { IAntDProTableRequest } from "../../../general/type/general.types";
import { apiRequest, downloadFile } from "../../../services/api";
import { IPayslipRequest, IApiResponseGetPayslips } from "../type/payslip";

export const getPayslips = async (
  tableRequest: IAntDProTableRequest
): Promise<IApiResponseGetPayslips> => {
  const response = await apiRequest("GET", "/payslips", tableRequest);
  return response.data;
};

export const getUserPayslips = async (
  userId: string,
  tableRequest: IAntDProTableRequest
): Promise<IApiResponseGetPayslips> => {
  const response = await apiRequest(
    "GET",
    `/payslips/user-payslips/${userId}`,
    tableRequest
  );
  return response.data;
};

export const createPayslip = async (data: IPayslipRequest) => {
  const response = await apiRequest<IPayslipRequest>("POST", "/payslips", data);
  return response.data;
};

export const getPayslipById = async (id: string | undefined) => {
  const response = await apiRequest<IApiResponseGetPayslips>(
    "GET",
    `/payslips/${id}`
  );
  return response.data;
};

export const editPayslip = async (id: string, data: IPayslipRequest) => {
  const response = await apiRequest<IPayslipRequest>(
    "PATCH",
    `/payslips/${id}`,
    data
  );
  return response.data;
};

export const archivePayslip = async (id: string) => {
  const response = await apiRequest("PATCH", `/payslips/${id}/archive`);
  return response.data;
};

export const downloadPayslipFileFromS3 = async (
  payslipId: string,
  relativePath: string
) => {
  try {
    // Use the standardized downloadFile function to get the blob
    const blob = await downloadFile(
      `/payslips/${payslipId}/download?filePath=${encodeURIComponent(
        relativePath
      )}`
    );

    // Get the filename from the relative path
    const fileName = relativePath.split("/").pop() || "downloaded-file";

    // Create download URL
    const downloadUrl = window.URL.createObjectURL(blob);

    // *** Try to open in new tab for supported file types (PDF, images) *** //
    const isPdf = blob.type === "application/pdf";
    const isImage = blob.type.startsWith("image/");

    if (isPdf || isImage) {
      // Open in new tab for supported file types
      const newTab = window.open(downloadUrl, "_blank");

      // Fallback to download if opening in new tab fails
      if (!newTab || newTab.closed || typeof newTab.closed === "undefined") {
        // Browser blocked opening new tab, fall back to download
        triggerDownload(downloadUrl, fileName);
      } else {
        // Revoke the blob URL when the parent page is closed/refreshed
        // This prevents the blob URL from being reused after closing the parent tab
        window.addEventListener(
          "beforeunload",
          () => {
            window.URL.revokeObjectURL(downloadUrl);
          },
          { once: true }
        );
      }
    } else {
      // For other file types, use regular download
      triggerDownload(downloadUrl, fileName);
    }
    return true;
  } catch (error) {
    console.error("Error downloading file:", error);
    throw error;
  }
};

// Helper function to trigger file download
const triggerDownload = (url: string, fileName: string) => {
  const link = document.createElement("a");
  link.href = url;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();

  // Clean up
  setTimeout(() => {
    window.URL.revokeObjectURL(url);
    document.body.removeChild(link);
  }, 100);
};
